import type { RoomUnreadView } from '#src/generated/protocol';

export type UnreadBadgeMode = 'dot' | 'count';

export type UnreadBadgeCounts = Pick<RoomUnreadView, 'unread' | 'highlight'> &
  Partial<Pick<RoomUnreadView, 'marked' | 'notifying'>>;

export interface UnreadBadgeSettings {
  showUnreadCounts: boolean;
  badgeCountDMsOnly: boolean;
  showPingCounts: boolean;
}

export interface UnreadBadgeView {
  mode: UnreadBadgeMode;
  count: number;
  highlight: boolean;
}

export function resolveUnreadBadge(
  counts: UnreadBadgeCounts | undefined,
  settings: UnreadBadgeSettings,
  dm = false
): UnreadBadgeView | null {
  if (counts === undefined) return null;

  const mention = counts.highlight > 0;
  const count = mention ? counts.highlight : counts.unread;
  if (count <= 0) {
    return counts.marked ? { mode: 'dot', count: 0, highlight: false } : null;
  }

  const notified = (counts.notifying ?? 0) > 0;
  const highlight = mention || notified;
  const numeric = mention
    ? settings.showPingCounts
    : notified || (dm ? settings.badgeCountDMsOnly : settings.showUnreadCounts);
  if (!numeric) return { mode: 'dot', count, highlight };

  return {
    mode: 'count',
    count: notified && !mention ? (counts.notifying ?? count) : count,
    highlight,
  };
}

export function hideQuietDot(
  badge: UnreadBadgeView | null,
  showUnreadDots: boolean
): UnreadBadgeView | null {
  if (showUnreadDots || badge === null) return badge;
  return badge.mode === 'dot' && !badge.highlight && badge.count > 0 ? null : badge;
}

export function formatUnreadCount(count: number, showEasterEggs = false): string {
  if (count <= 999) return String(count);
  if (count === 1000) return '1k';

  return showEasterEggs ? ':3' : '1k+';
}
